import './ActivityDetail.less'
import { useSearchParams } from 'react-router-dom'

const CulturePalaceDetail = () => {
  const [ params ] = useSearchParams()
  const prevId = params.getAll('id')[0]

  return (
    <div className='pg-activity-detail'>
      <img className='detial-img' src={`https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/activity/detail-${prevId}.png`} />
    </div>
  )
}

export default CulturePalaceDetail